import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

type Dir = 'up' | 'down' | 'left' | 'right';

@Component({
  selector: 'app-block-iframe-editor-modal',
  templateUrl: './block-iframe-editor-modal.component.html',
  styleUrls: ['./block-iframe-editor-modal.component.scss'],
  standalone: false,
})
export class BlockIframeEditorComponent {
  @ViewChild('canvas', { static: false }) canvas?: ElementRef<HTMLDivElement>;

  clonedHtml = '';
  source = '';
  sourceMode = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { element: HTMLElement },
    public dialogRef: MatDialogRef<BlockIframeEditorComponent>
  ) {
    this.clonedHtml = data.element.outerHTML;
    this.source = data.element.innerHTML; // tylko zawartość!
  }

  /** 1  Przesuwanie */
  move(dir: Dir): void {
    const el = this.data.element;
    const parent = el.parentElement!;
    const prev = el.previousElementSibling as HTMLElement | null;
    const next = el.nextElementSibling as HTMLElement | null;

    if ((dir === 'up' || dir === 'left') && prev) parent.insertBefore(el, prev);
    if ((dir === 'down' || dir === 'right') && next)
      parent.insertBefore(next, el);
  }

  /** 2  Upload obrazka (tylko wizualny) */
  onFile(ev: Event): void {
    const file = (ev.target as HTMLInputElement).files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      const img = this.data.element.querySelector('img');
      if (img) img.src = reader.result as string;
      this.clonedHtml = this.data.element.outerHTML;
    };
    reader.readAsDataURL(file);
  }

  /** 3  Dodaj wewnętrzny blok (tylko wizualny) */
  addBlock(): void {
    const block = document.createElement('div');
    block.className = 'block_';
    block.textContent = 'Nowy blok';
    this.data.element.appendChild(block);
    this.clonedHtml = this.data.element.outerHTML;
  }

  /** 4  Przełącz tekst/kod */
  toggleSource(): void {
    if (this.sourceMode) {
      this.data.element.innerHTML = this.source;
      this.clonedHtml = this.data.element.outerHTML;
    }
    this.sourceMode = !this.sourceMode;
  }

  /** 5  Zastosuj & zamknij */
  apply(): void {
    if (this.sourceMode) {
      this.data.element.innerHTML = this.source;
    }
    this.dialogRef.close();
  }
}
